// extracted by mini-css-extract-plugin
module.exports = {"top":"styles_top__1yFlB","form":"styles_form__2lhXq"};